import React from 'react';
import PropTypes from 'prop-types';
import YellowTag from '@/components_cards/tags/_base/YellowTag';

HiddenTag.propTypes = {
  resource: PropTypes.shape({
    data: PropTypes.shape({
      published: PropTypes.bool,
    }),
  }).isRequired
};

export default function HiddenTag(props) {
  const { resource } = props;

  if (resource?.data?.published) {
    return null;
  }

  return (
    <YellowTag label="HIDDEN" />
  );
}
